import React from "react";
import { LegalPage } from "../components/LegalPage";

// Verbatim text from the official Privacy Policy (Effective Date 1.8.2026).
// DO NOT rewrite, summarise, or paraphrase any wording below.
const sections = [
  {
    id: "sec-1",
    number: "1.",
    title: "Introduction",
    body: [
      {
        type: "p",
        text: "MiseOne (\u201Cwe\u201D, \u201Cour\u201D, or \u201Cus\u201D) is committed to protecting your privacy and handling your Personal Data responsibly.",
      },
      {
        type: "p",
        text: "This Privacy Policy explains how we collect, use, store, disclose, and protect Personal Data when you use the MiseOne website, customer portal, or cloud-based Platform (the \u201CServices\u201D).",
      },
      {
        type: "p",
        text: "By using our Services, you acknowledge that your Personal Data may be processed as described in this Privacy Policy.",
      },
    ],
  },
  {
    id: "sec-2",
    number: "2.",
    title: "Who We Are",
    body: [
      { type: "label", text: "Data Controller" },
      { type: "p", text: "MiseOne" },
      { type: "p", text: "Email: info@miseone.eu" },
      { type: "p", text: "Website: www.miseone.eu" },
      {
        type: "p",
        text: "If you have questions regarding this Privacy Policy or wish to exercise your privacy rights, you may contact us using the details above.",
      },
    ],
  },
  {
    id: "sec-3",
    number: "3.",
    title: "Personal Data We Collect",
    body: [
      { type: "p", text: "Depending on how you use our Services, we may collect:" },
      {
        type: "ul",
        items: [
          "Name",
          "Business email address",
          "Business telephone number",
          "Company name",
          "Job title",
          "User account information",
          "Login information",
          "IP address",
          "Device and browser information",
          "Usage information",
          "Support communications",
          "Billing information",
        ],
      },
      {
        type: "p",
        text: "We do not intentionally collect special categories of Personal Data unless required by the Customer and permitted by applicable law.",
      },
    ],
  },
  {
    id: "sec-4",
    number: "4.",
    title: "How We Use Personal Data",
    body: [
      { type: "p", text: "We use Personal Data to:" },
      {
        type: "ul",
        items: [
          "provide the Services;",
          "create and manage user accounts;",
          "authenticate users;",
          "provide customer support;",
          "process billing and payments;",
          "maintain Platform security;",
          "improve our Services;",
          "comply with legal obligations.",
        ],
      },
      { type: "p", text: "We do not sell Personal Data." },
    ],
  },
  {
    id: "sec-5",
    number: "5.",
    title: "Legal Basis",
    body: [
      {
        type: "p",
        text: "Depending on the circumstances, we process Personal Data based on one or more of the following legal grounds:",
      },
      {
        type: "ul",
        items: [
          "performance of a contract;",
          "compliance with legal obligations;",
          "legitimate interests;",
          "consent, where required.",
        ],
      },
    ],
  },
  {
    id: "sec-6",
    number: "6.",
    title: "Sharing Personal Data",
    body: [
      { type: "p", text: "We may share Personal Data only where necessary with:" },
      {
        type: "ul",
        items: [
          "trusted cloud infrastructure providers;",
          "payment providers;",
          "email service providers;",
          "authorised subprocessors;",
          "public authorities where required by law.",
        ],
      },
      { type: "p", text: "All third parties are required to protect Personal Data appropriately." },
    ],
  },
  {
    id: "sec-7",
    number: "7.",
    title: "International Transfers",
    body: [
      {
        type: "p",
        text: "Where Personal Data is transferred outside the European Economic Area (EEA), appropriate safeguards will be implemented in accordance with the GDPR.",
      },
    ],
  },
  {
    id: "sec-8",
    number: "8.",
    title: "Data Retention",
    body: [
      { type: "p", text: "We retain Personal Data only for as long as necessary to:" },
      {
        type: "ul",
        items: [
          "provide the Services;",
          "comply with legal obligations;",
          "resolve disputes;",
          "enforce our agreements;",
          "maintain backup integrity.",
        ],
      },
      {
        type: "p",
        text: "After the applicable retention period, Personal Data is securely deleted or anonymised.",
      },
    ],
  },
  {
    id: "sec-9",
    number: "9.",
    title: "Your Rights",
    body: [
      { type: "p", text: "Subject to applicable law, you may have the right to:" },
      {
        type: "ul",
        items: [
          "access your Personal Data;",
          "correct inaccurate information;",
          "request deletion;",
          "restrict processing;",
          "object to processing;",
          "request data portability;",
          "withdraw consent where processing is based on consent;",
          "lodge a complaint with your supervisory authority.",
        ],
      },
    ],
  },
  {
    id: "sec-10",
    number: "10.",
    title: "Security",
    body: [
      {
        type: "p",
        text: "We implement appropriate technical and organisational measures designed to protect Personal Data.",
      },
      {
        type: "p",
        text: "These measures include encryption, secure cloud infrastructure, access controls, audit logging, backups, and regular security updates.",
      },
      { type: "p", text: "No internet-based service can be guaranteed to be completely secure." },
    ],
  },
  {
    id: "sec-11",
    number: "11.",
    title: "Changes to this Privacy Policy",
    body: [
      { type: "p", text: "We may update this Privacy Policy from time to time." },
      { type: "p", text: "The latest version will always be available on our website." },
      { type: "p", text: "Where required by law, we will notify users of material changes." },
    ],
  },
  {
    id: "sec-12",
    number: "12.",
    title: "Contact",
    body: [
      { type: "p", text: "For privacy-related questions or requests, please contact:" },
      { type: "p", text: "Email: Info@miseone.eu" },
      { type: "p", text: "Website: www.miseone.eu" },
    ],
  },
];

export const PrivacyPolicy = () => (
  <LegalPage
    eyebrow="Legal"
    title="Privacy Policy"
    effectiveDate="1.8.2026"
    lastUpdated="1.8.2026"
    sections={sections}
    testId="privacy-page"
  />
);

export default PrivacyPolicy;
